import { render } from "./whiteboard.vue?vue&type=template&id=73b2e7fc&scoped=true"
import script from "./whiteboard.vue?vue&type=script&lang=js"
export * from "./whiteboard.vue?vue&type=script&lang=js"

import "./whiteboard.vue?vue&type=style&index=0&id=73b2e7fc&lang=scss&scoped=true"
import "./whiteboard.vue?vue&type=style&index=1&id=73b2e7fc&lang=css"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b2e7fc"]])

export default __exports__